import type { Components } from '@mildang/mui';

const createStack = (): Components => ({
  MuiStack: {
    defaultProps: {
      direction: 'row',
    },
  },
});

export default createStack;
